<template>
  <common-layout>
    <div class="LearningRecord">
      <record-list :record-list="recordList"></record-list>
      <div class="tabs">
        <span
          :class="['tabs_item', tabSwitch ? 'tabActive' : '']"
          @click="handleTabs(true)"
        ></span>
        <span
          :class="['tabs_item', tabSwitch ? '' : 'tabActive']"
          @click="handleTabs(false)"
        ></span>
      </div>
      <div
        class="line_charts"
        ref="lineCharts"
        style="width: 100%; height: 300px"
        v-show="tabSwitch"
      />
      <div v-show="!tabSwitch" style="width: 100%">
        <el-calendar v-model="value">
          <!-- 这里使用的是 2.5 slot 语法，对于新项目请使用 2.6 slot 语法-->
          <template slot="dateCell" slot-scope="{ data }">
            <calendarItem
              :itemdate="formDate(data.day)"
              @setCalendarItem="getCalendarItem"
            ></calendarItem>
          </template>
        </el-calendar>
      </div>
      <ul class="course_box" v-loading="courseTimeLoading">
        <li v-for="timeItem in courseTimeList" :key="timeItem.date">
          <h3><i class="el-icon-date"></i>{{ timeItem.date }}</h3>
          <div class="cursor_list">
            <learning-details
              class="cursor_item"
              v-for="item in timeItem.list"
              :key="item.id"
              :cursorDetail="item"
              v-on="$listeners"
              @setEqual="getEqual"
              :d-height="dHeight"
            />
          </div>
        </li>
        <div class="pagination_box" v-if="courseTimeTotal > 0">
          <el-pagination
            background
            layout="total,prev, pager, next"
            :total="courseTimeTotal"
            :page-size="pageSize"
            :current-page="pageNum"
            @current-change="handleCurrentChange"
            :hide-on-single-page="false"
          >
          </el-pagination>
        </div>
        <el-empty v-if="courseTimeList.length == 0" description="暂无学习记录"></el-empty>
      </ul>
    </div>
  </common-layout>
</template>
<script>
import echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import resize from "@/utils/chartsMixinsResize";

import {
  studyProfile,
  getMyStudyDayAndTime,
  getTrainingStudyRecordHistory,
  getTraineeCheckInDate,
  getStudyRecordHistoryByDate,
  getStudyTimeline,
} from "@/api/user";
import CommonLayout from "@/components/LearningCenterComponents/Common";
import calendarItem from "@/components/LearningCenterComponents/calendarItem";
import LearningDetails from "@/components/LearningDetails";
import RecordList from "./recordList";

import { parseDate } from "@/utils";
export default {
  components: {
    CommonLayout,
    LearningDetails,
    RecordList,
    calendarItem,
  },
  data() {
    return {
      year: "",
      columns: "",
      archivesItem: [],
      loading: false,
      dHeight: 0,
      recordList: [
        {
          label: "累计学习时长(小时)",
          num: 0,
        },
        {
          label: "今日学习时长(分钟)",
          num: 0,
        },
        {
          label: "累计学习天数(天)",
          num: 0,
        },
        {
          label: "连续学习天数(天)",
          num: 0,
        },
      ],
      lineChart: null,
      lineOption: {
        grid: {
          top: 30,
          left: 20,
          right: 40,
          bottom: 10,
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisTick: { show: false },
            splitLine: {
              show: true,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: "#333333",
            },
            boundaryGap: false,
            data: [],
          },
        ],
        yAxis: [
          {
            type: "value",
            axisTick: {
              show: false,
            },
            splitArea: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              color: "#333333",
            },
          },
        ],
        series: [
          {
            name: "Fake Data",
            type: "line",
            smooth: true,
            symbol: "circle",
            symbolSize: 8,
            sampling: "average",
            itemStyle: {
              color: "#045923",
            },
            label: {
              show: true,
              position: "top",
              formatter: function (params) {
                return parseInt((params.value / 60) * 10) / 10 + "分钟";
              },
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "rgba(4,89,35,1)",
                },
                {
                  offset: 1,
                  color: "rgba(4,89,35,.3)",
                },
              ]),
            },
            data: [],
          },
        ],
      },
      tabSwitch: true,
      value: new Date(),
      monthList: [],

      courseTimeList: [],
      courseTimeLoading: false,
      courseTimeTotal: 0,
      pageNum: 1,
      pageSize: 5,
    };
  },
  created() {
    this.year = new Date().getFullYear();
    this.columns = [this.year, this.year - 1, this.year - 2];
    this.getStudyProfile(this.year);

    this.getMyStudyDayAndTime();
    this.getStudyTimeline();
  },
  mounted() {
    this.queryMonthMatch();
    this.initChart();
    this.getTrainingStudyRecordHistory();
    this.$nextTick(() => {
      // 点击前一个月
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          this.queryMonthMatch();
        });
      }
    });
    this.$nextTick(() => {
      // 点击当前月
      let currentBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      if (currentBtn) {
        currentBtn.addEventListener("click", () => {
          this.queryMonthMatch();
        });
      }
    });
    this.$nextTick(() => {
      // 点击后一个月
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:last-child"
      );
      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          this.queryMonthMatch();
        });
      }
    });
  },
  beforeDestroy() {
    //销毁绑定事件
    let prevBtnPre = document.querySelector(
      ".el-calendar__button-group .el-button-group>button:nth-child(1)"
    );
    let currentBtn = document.querySelector(
      ".el-calendar__button-group .el-button-group>button:nth-child(2)"
    );
    let prevBtnNext = document.querySelector(
      ".el-calendar__button-group .el-button-group>button:last-child"
    );
    if (prevBtnPre) {
      prevBtnPre.removeEventListener("click", () => {
        this.queryMonthMatch();
      });
    }

    if (currentBtn) {
      currentBtn.removeEventListener("click", () => {
        this.queryMonthMatch();
      });
    }

    if (prevBtnNext) {
      prevBtnNext.removeEventListener("click", () => {
        this.queryMonthMatch();
      });
    }
  },
  methods: {
    getStudyProfile(year) {
      this.loading = true;
      getStudyRecordHistoryByDate({
        traineeId: this.$store.getters.userId,
        currentDate: parseDate(this.value, "{y}-{m}-{d}"),
      })
        .then((res) => {
          console.log(res);
          this.loading = false;
          this.archivesItem = res.rows.map((v) => {
            return { ...v, title: v.chapterName, classHours: v.duration };
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getStudyTimeline() {
      this.courseTimeLoading = true;
      getStudyTimeline({
        traineeId: this.$store.getters.userId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      })
        .then((res) => {
          this.courseTimeLoading = false;
          this.courseTimeList = res.rows.map((v) => {
            v.list = v.list.map((k) => {
              return { ...k, title: k.chapterName, classHours: k.duration };
            });
            return v;
          });
          console.log(this.courseTimeList);
          this.courseTimeTotal = res.total;
        })
        .catch(() => {
          this.courseTimeLoading = false;
        });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getStudyTimeline();
    },
    handleChange(val) {
      this.getStudyProfile(val);
    },
    getEqual(h) {
      this.dHeight = this.dHeight < h ? h : this.dHeight;
    },
    getMyStudyDayAndTime() {
      getMyStudyDayAndTime({ traineeId: this.$store.getters.userId }).then((res) => {
        this.recordList[3].num = res.day; //连续学习天数
        this.recordList[2].num = res.sumStudyDay; // 累计学习天数
        this.recordList[0].num = parseInt((res.sumStudyTime / 60 / 60) * 10) / 10; //累计学习时长
        this.recordList[1].num = parseInt((res.todayStudyTime / 60) * 10) / 10; //今日学习时长
      });
    },
    initChart() {
      this.lineChart = echarts.init(this.$refs.lineCharts, "macarons");
      this.lineChart.on("click", (e) => {
        this.getCalendarItem(new Date(e.name));
      });
    },
    handleTabs(flag) {
      this.tabSwitch = flag;
      if (flag) {
        this.getTrainingStudyRecordHistory();
      }
    },
    getTrainingStudyRecordHistory() {
      getTrainingStudyRecordHistory({
        day: 7,
        traineeId: this.$store.getters.userId,
      }).then((res) => {
        this.lineOption.xAxis[0].data = res.studyDate;
        this.lineOption.series[0].data = res.studyTime;
        this.lineChart.setOption(this.lineOption);
      });
    },
    formDate(date) {
      var obj = {
        date,
        isSelect: false,
      };
      if (this.monthList.indexOf(date) > -1) {
        obj.isSelect = true;
      }
      return obj;
    },
    async queryMonthMatch(yymm) {
      const r = await getTraineeCheckInDate({
        traineeId: this.$store.getters.userId,
        month: parseDate(this.value, "{m}"),
        year: parseDate(this.value, "{y}"),
      });
      this.monthList = r.dateList;
    },
    getCalendarItem(date) {
      this.value = date;
      this.getStudyProfile();
    },
  },
};
</script>
<style lang="scss" scoped>
.LearningRecord {
  padding: 30px 0;
  ::v-deep {
    .el-button:active {
      color: #1d4434;
      border-color: #1d4434;
    }
    .el-button:focus,
    .el-button:hover {
      color: #1d4434;
      border-color: #ffe0c1;
      background-color: #fff5ec;
    }
    .el-calendar-table .el-calendar-day {
      height: 50px;
    }
    .el-calendar-table thead th{
      text-align: center;
    }
    .el-calendar-table:not(.is-range) td.next {
      /*隐藏下个月的日期*/
      visibility: hidden;
    }

    .el-calendar-table:not(.is-range) td.prev {
      /*隐藏上个月的日期*/
      visibility: hidden;
    }
    .current .el-calendar-day {
      padding: 0;
    }
    .el-calendar-table td.is-selected {
      background-color: #fff6ec;
    }
    .el-calendar-table .el-calendar-day:hover {
      background-color: #fff6ec;
    }
    .el-backtop,
    .el-calendar-table td.is-today {
      color: #1d4434;
    }
  }
  .course_footer {
    text-align: center;
    color: #999;
  }
  .course_box {
    h3 {
      color: #1d4434;
      font-size: 16px;
      margin-bottom: 25px;
      i {
        margin-right: 12px;
      }
    }
    .cursor_list {
      display: flex;
      flex-wrap: wrap;
      margin-left: -7px;
      margin-right: -7px;
      .cursor_item {
        width: 25%;
        margin-bottom: 40px;
        ::v-deep .cursor_inner {
          background: #fff;
        }
      }
    }
    .pagination_box {
      text-align: center;
    }
  }
}

.tabs {
  display: flex;
  justify-content: flex-end;
  span {
    width: 48px;
    height: 38px;
    border: 1px solid #d2d2d2;
    cursor: pointer;
    &:first-child {
      border-radius: 6px 0 0 6px;
      background: url("~@/assets/images/tabs.png") no-repeat;
      background-position: 12px 5px;
      border-right: none;
      position: relative;
      &::before {
        content: " ";
        position: absolute;
        top: 50%;
        right: -0.5px;
        width: 1px;
        height: 24px;
        background: #cccccc;
        border-radius: 1px;
        transform: translateY(-50%);
      }
    }
    &:last-child {
      border-radius: 0 6px 6px 0;
      background: url("~@/assets/images/tabs.png") no-repeat;
      background-position: -30px 6px;
      border-left: none;
    }
    &.tabActive:first-child {
      border-radius: 6px 0 0 6px;
      background-position: 12px -27px;
    }
    &.tabActive:last-child {
      border-radius: 0 6px 6px 0;
      background-position: -30px -26px;
    }
  }
}
.line_charts {
  padding-bottom: 50px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 40px;
  margin-top: 10px;
}
</style>
